export default "__VITE_ASSET__e7396adb__"